import React, { createContext, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useAuth from '../hooks/useAuth';
import api from '../services/api';
import { lerCoordenadorEscolhido, salvarCoordenadorEscolhido } from '../services/coordenadorAtuacao';
import SearchableSelect from './SearchableSelect';
import '../styles/Formulario.css';

// Telas do coordenador abertas pelo admin ou Exxer: antes de qualquer coisa, a
// pessoa escolhe em nome de qual coordenador vai agir (obrigatorio). A tela so
// aparece depois da escolha e e remontada quando ela muda. O coordenador entra
// direto, como sempre.

const CoordenadorAtuacaoContext = createContext(null);

// Coordenador em nome de quem a tela age (null quando quem esta logado ja e o
// coordenador).
export const useCoordenadorAtuacao = () => useContext(CoordenadorAtuacaoContext);

const ExigeCoordenador = ({ children }) => {
  const { t } = useTranslation('coordinator');
  const { usuario } = useAuth();
  const ehCoordenador = usuario?.tipo_usuario === 'coordenador';
  const [coordenadores, setCoordenadores] = useState([]);
  const [carregando, setCarregando] = useState(!ehCoordenador);
  const [escolhido, setEscolhido] = useState(() => (ehCoordenador ? null : lerCoordenadorEscolhido()));

  useEffect(() => {
    if (ehCoordenador) return undefined;
    let ativo = true;
    api.get('/usuarios', { params: { tipo: 'coordenador' }, semCoordenador: true })
      .then(({ data }) => {
        if (!ativo) return;
        const lista = Array.isArray(data) ? data : [];
        setCoordenadores(lista);
        // Escolha antiga de um coordenador que nao existe mais nao vale.
        setEscolhido((atual) => (atual && lista.some((c) => c.id === atual.id) ? atual : null));
      })
      .catch(() => ativo && setCoordenadores([]))
      .finally(() => ativo && setCarregando(false));
    return () => { ativo = false; };
  }, [ehCoordenador]);

  if (ehCoordenador) return children;

  const escolher = (id) => {
    const coordenador = coordenadores.find((c) => String(c.id) === String(id)) || null;
    salvarCoordenadorEscolhido(coordenador);
    setEscolhido(coordenador);
  };

  return (
    <CoordenadorAtuacaoContext.Provider value={escolhido}>
      <div className="pagina-conteudo coordenador-atuacao">
        <div className={`coordenador-atuacao-barra${escolhido ? '' : ' pendente'}`}>
          <label htmlFor="coordenador-atuacao">{t('acting.label')} *</label>
          <SearchableSelect
            id="coordenador-atuacao"
            value={escolhido ? String(escolhido.id) : ''}
            onChange={escolher}
            placeholder={carregando ? t('acting.loading') : t('acting.choose')}
            options={coordenadores.map((c) => ({ value: String(c.id), label: `${c.nome} — ${c.email}` }))}
          />
          <small>{t('acting.hint')}</small>
        </div>
      </div>
      {escolhido
        ? <React.Fragment key={escolhido.id}>{children}</React.Fragment>
        : !carregando && (
          <div className="pagina-conteudo">
            <p className="coordenador-atuacao-aviso">{coordenadores.length ? t('acting.required') : t('acting.none')}</p>
          </div>
        )}
    </CoordenadorAtuacaoContext.Provider>
  );
};

export default ExigeCoordenador;
